const BankIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="bank-icon btn-icon-1 h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path d="M14.324 11.387c-.547-1.272-2.073-2.124-3.41-1.901-1.337.222-1.979 1.433-1.432 2.706.578 1.343 2.234 2.202 3.598 1.863 1.209-.299 1.766-1.456 1.244-2.668zm-1.683 1.584l.12.267-.253.052-.113-.254c-.262.047-.561.041-.836-.031l-.076-.451c.227.035.509.067.725.023l.145-.047c.258-.126.179-.449-.204-.525-.284-.063-1.038-.017-1.319-.642-.158-.353-.041-.722.414-.891l-.125-.278.252-.052.12.266c.185-.031.401-.042.655-.02l.102.446c-.197-.025-.41-.047-.596-.009l-.07.018c-.359.095-.244.436.075.519.527.122 1.156.161 1.404.712.199.445-.034.75-.42.897zm6.389-5.535l2.751 6.004c-4.729 2.523-11.228-.197-16.896 2.941l-2.736-5.972c.74-.515 1.562-.876 2.518-1.113 3.358-.833 7.543.079 11.852-.99.885-.22 1.718-.508 2.511-.87zm.809-2.436c-6.829 4.423-14.376-.351-19.839 4.92l4.161 9.08c5.854-4.962 13.835-.264 19.839-4.92l-4.161-9.08z" />
    </svg>
  );
};
export default BankIcon;
